import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[stopClickPropagation]',
  standalone: true,
})
export class SiaClickStopPropagation {
  @HostListener('click', ['$event'])
  public onClick(event: Event): void {
    // console.log('stopClickPropagation');
    event.stopPropagation();
    event.preventDefault();
  }
}
